<h2 mat-dialog-title>{{ data.title | translate }}</h2>

<mat-dialog-content class="mat-typography">
  <form class="form-wrapper" [formGroup]="spesenForm" autocomplete=off>
    <div class="eineLinie">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.zeitverwaltung.spesenDialog.spesencode' | translate }}</mat-label>
        <mat-select [compareWith]="compareFn" (selectionChange)="fillUpAnsatz($event.value)" formControlName="spesencode">
          <mat-option *ngFor="let spesenart of ($spesenarten | async)" [value]="spesenart">
            {{spesenart.bezeichnung }}
          </mat-option>
        </mat-select>
      </mat-form-field>

    </div>


    <div class="zweiLinien">
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.zeitverwaltung.spesenDialog.menge' | translate }}</mat-label>
        <input
          (focusout)="rechneBetrag()"
          matInput
          [placeholder]="'pages.zeitverwaltung.spesenDialog.menge' | translate"
          formControlName="menge"
          [decimalNumbersOnlyMax]="1000000"
          [kommaStellen]="2"
        />
        <mat-error *ngIf="spesenForm.controls.menge.invalid">{{ getErrorMessage('menge') | translate }}</mat-error>
      </mat-form-field>
      <div *ngIf="isSmallDevice"></div>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.zeitverwaltung.spesenDialog.ansatzInt' | translate }}</mat-label>
      <input
        (focusout)="rechneBetrag()"
        matInput
        [placeholder]="'pages.zeitverwaltung.spesenDialog.ansatzInt' | translate"
        formControlName="ansatzInt"
        [decimalNumbersOnlyMax]="1000000"
        [kommaStellen]="2"
      />
      <mat-error *ngIf="spesenForm.controls.ansatzInt.invalid">{{ getErrorMessage('ansatzInt') | translate }}</mat-error>
    </mat-form-field>
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.zeitverwaltung.spesenDialog.betragInt' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.zeitverwaltung.spesenDialog.betragInt' | translate"
        formControlName="betragInt"
        [decimalNumbersOnlyMax]="1000000"
        [kommaStellen]="2"
      />
      <mat-error *ngIf="spesenForm.controls.betragInt.invalid">{{ getErrorMessage('betragInt') | translate }}</mat-error>
    </mat-form-field>

      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.zeitverwaltung.spesenDialog.ansatzExt' | translate }}</mat-label>
        <input
          (focusout)="rechneBetrag()"
          matInput
          [placeholder]="'pages.zeitverwaltung.spesenDialog.ansatzExt' | translate"
          formControlName="ansatzExt"
          [decimalNumbersOnlyMax]="1000000"
          [kommaStellen]="2"
        />
        <mat-error *ngIf="spesenForm.controls.ansatzExt.invalid">{{ getErrorMessage('ansatzExt') | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.zeitverwaltung.spesenDialog.betragExt' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.zeitverwaltung.spesenDialog.betragExt' | translate"
          formControlName="betragExt"
          [decimalNumbersOnlyMax]="1000000"
          [kommaStellen]="2"
        />
        <mat-error *ngIf="spesenForm.controls.betragExt.invalid">{{ getErrorMessage('betragExt') | translate }}</mat-error>
      </mat-form-field>
    </div>


      <mat-form-field appearance="outline" color="accent" >
        <mat-label>{{ 'pages.zeitverwaltung.spesenDialog.beschreibung' | translate }}</mat-label>
        <textarea
          matInput
          [placeholder]="'pages.zeitverwaltung.spesenDialog.beschreibung' | translate"
          formControlName="beschreibung"
        ></textarea>
      </mat-form-field>

  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button
    [tabIndex]="-1"
    id="abbruch"
    color="accent"
    (click)="handleCancelClick()"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    mat-raised-button
    color="accent"
    (click)="handleSubmitClick()"
    [disabled]="spesenForm.invalid"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
